export default __webpack_public_path__ + "static/media/MM-Img3.09c253a9.png";